import { render } from "./TeamPlayers.vue?vue&type=template&id=36d12338&scoped=true"
import script from "./TeamPlayers.vue?vue&type=script&lang=js"
export * from "./TeamPlayers.vue?vue&type=script&lang=js"

import "./TeamPlayers.vue?vue&type=style&index=0&id=36d12338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d12338"]])

export default __exports__